module.exports = __webpack_public_path__ + "img/drug-5.5c876a60.png";